module.exports = __webpack_public_path__ + "static/media/chatbot-image.31a0ccc0.png";